import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { EMPTY, Observable, Subscription, switchMap } from 'rxjs';
import { ApplicantSitesNav, NavbarTypes } from 'talos-careers-page-library';
import { SiteConfigState } from './models/site.config.models';
import { BrandingService } from './services/branding.service';
import { HttpService } from './services/http.service';
import { LoginService } from './services/login.service';
import { MetaDataService } from './services/meta-data.service';
import { LocalStorage } from './constants/local-storage';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'onboarding-portal';

  public siteConfig: SiteConfigState = {} as SiteConfigState;
  public subscription$: Subscription = new Subscription;

  public siteFound = true;
  public currentRoute: string = '';
  public navbarType: NavbarTypes = NavbarTypes.HORIZONTAL;
  public isBurgerMenuOpen = false;

  public applicantSitesNav$: Observable<ApplicantSitesNav | null> = this.httpService.applicantSitesNav$;

  private _accessToken = '';

  constructor(
    private httpService: HttpService,
    private brandingService: BrandingService,
    private router: Router,
    private metaDataService: MetaDataService,
    private loginService: LoginService,
    activatedRoute: ActivatedRoute
  ) {
    this.siteConfig = this.brandingService.getDefaultSiteConfigState();

    this.subscription$.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
      }
    }));
    // TECHNICAL DEBT
    // The below can be removed when we refactor login.
    activatedRoute.queryParams.subscribe(queryParams => this.onQueryStringLoaded(queryParams['accessToken']));
  }

  ngOnInit(): void {
    this.subscription$.add(this.httpService.getSiteConfig().subscribe({
      next: result => {
        this.brandingService.addBranding(result.onboardingSiteConfig);
        localStorage.setItem(LocalStorage.OBFUSCATED_SITE_ID, result.onboardingSiteConfig.obfuscatedId);

        // TECHNICAL DEBT
        // We've had to move this call to app.component.ts to enable auto-login.
        // When we add a proper login screen in future we can look at refactoring
        // this call back into login.page.ts.

        if (this.router.url.split('?')[0] == '/login') {
          this.loginService.login(this._accessToken);
        }
      },
      error: err => {
        this.siteFound = false;
        this.metaDataService.setTitle("Site Not Found");
        this.router.navigateByUrl(`invalid`);
        return EMPTY;
      }
    }));

    this.subscription$.add(this.brandingService.branding$.subscribe(data => {
      this.siteConfig = data;
      this.navbarType = this.siteConfig.navigation.navigationType;
      this.metaDataService.setFavicon(this.siteConfig.globalStyles.faviconUrl);
    }));

    this.subscription$.add
    (
      this.loginService
      .getAccessToken()
      .pipe
      (
        switchMap(accessToken => {
          if (accessToken) {
            return this.httpService.applicantSitesNav$.pipe(
              switchMap(siteNav => siteNav == null ? this.httpService.getSiteNavDetails() : EMPTY)
            ) 
          }
          else {
            return EMPTY;
          }
        })
      )
      .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public onToggleBurgerMenu(isOpen: boolean): void {
    this.isBurgerMenuOpen = isOpen;
  }

  // TECHNICAL DEBT
  // The below can be removed when we refactor login.
  onQueryStringLoaded(accessToken: string): void {
    this._accessToken = accessToken;
  }
}
